export default () => ({
  component: 'date-filter',
  componentAttrs: {
    label: '',
  },
});
